import React, { useState, useEffect, useContext } from "react";
import Tab from "../tab/tab";
import TopBar from "../../scenes/global/Top-Bar";
import SideBar from "../../scenes/global/Side-Bar";
import BasicSelect from "../select/select";
import AddedItem from "../added_item/added_item";
import AddMore from "../add_more/add_more";
import ViewProp from "../view_prop/view";
import { useDispatch, useSelector } from "react-redux";
import { dispatchLanguage, lang_function, saveLanguage } from "../../Redux/ActionCreator";
import $, { event } from "jquery";
import {
  Languages,
  Rate,
  Rate_sp,
  Langu,
} from "../../scenes/step/data/languages";
import { ToastContainer, toast } from "react-toastify";
import { LanguageContext } from "../../scenes/global/languageContext";

export default function UserLanguage(props) {
  const { language, handleLanguageChange } = useContext(LanguageContext);
  const dispatch = useDispatch();
  const language_data = useSelector((lan) => lan.language);
  const profile1 = useSelector(e => e.login);
  const userInfo = useSelector(e => e.userInfo);
  let stat = profile1.profile_status.profile_status
  const secret = useSelector(prev => prev.secret);
  const lang_data = useSelector((lan) => lan.lang);
  const [chips, setChips] = useState([]);
  const [chipsL, setChipsL] = useState([]);
  const [languagess, setLanguage] = useState([]);
  const [res_lang, setres_lang] = useState([]);
  const [ lang_value, setLan_value ] = useState("");
  const [ lang_prof, setLan_prof ] = useState("");

  useEffect(() => {
    if (language_data.lang !== null) {
      setLanguage(language_data.lang);
      setChips(language_data.lang);
    }

    if (lang_data.lang !== null) {
      setres_lang(lang_data.lang);
      setChipsL(lang_data.lang);
    }
  }, [language_data.lang, lang_data.lang]);

  const handleDelete = (chipToDelete) => {
    const newlan = languagess.filter((element) => {
      if (element.key !== chipToDelete.key) return element;
    });
    console.log("new language", newlan);
    newlan.forEach((element) => {
      element.key = newlan.indexOf(element);
    });
    setLanguage(newlan);
    setChips(newlan);
    dispatch(dispatchLanguage(newlan));
    console.log("chips", chips);
    console.log("delete language", languagess);
  };

const handleAdd = () => {
  if ($('[name="language"]').val() === "") {
    setTimeout(() => {
      toast.error("Add the language you just filled", {
          position: toast.POSITION.TOP_RIGHT,
      });
    }, 50)
  } else {
    let newlan = languagess;
    let k = languagess.length;
     const data =  {
             key : k,
             language : lang_value,
             rate : lang_prof,
     }

       newlan?.push(data);
       setLanguage(newlan);
       setChips(newlan);
       dispatch(dispatchLanguage(newlan));
      setLan_value("")
      setLan_prof("")
  }
}

  let languages = [];
  for (let i = 0; i <= Languages.length - 1; i++) {
    languages.push(`${Languages[i].value}`);
  }

  let rate = [];
  for (let i = 0; i <= Rate.length - 1; i++) {
    rate.push(`${Rate[i].value}`);
  }

  let rate_sp = [];
  for (let i = 0; i <= Rate_sp.length - 1; i++) {
    rate_sp.push(`${Rate_sp[i].value}`);
  }

  let lang = [];
  for (let i = 0; i <= Langu.length - 1; i++) {
    lang.push(`${Langu[i].value}`);
  }

const handleNext = () => {
  if (stat === "false" || stat === false) {
    dispatch(saveLanguage(languagess, secret.secret))
  } 
  props.handleStepChange();
}

  return (
    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      <div className="px-3 lg:pl-6 my-8 w-full">
        <div className="w-full max-w-[793px] h-[54px] bg-white bg-opacity-50 rounded-[40px] shadow border border-indigo-400 border-opacity-30 flex flex-col justify-center">
          <p className="text-stone-950 text-base md:text-[28px] font-semibold ml-12 max-[300px]:ml-6">
            {language["resume_caph1"]}
          </p>
        </div>
        <p className="w-full max-w-[741px] mt-2 px-3 lg:pl-6">
          <span className="text-black text-opacity-50 text-[14px] md:text-base font-">
            {language["Hey_there"]}
          </span>
        </p>
        <div className="max-w-[800px] w-full mt-8 p-8 bg-white bg-opacity-80 rounded-2xl shadow border border-indigo-400 border-opacity-30 flex-col justify-start items-start gap-16 inline-flex">
          <div className="tabarea justify-start items-center gap-6 inline-flex w-full flex-shrink-0 w-full max-w-[calc(100vw-88px)] overflow-hidden">
            <Tab
              num="1"
              current={false}
              completed={true}
              className="max-[700px]:hidden"
            />
            <Tab
              num="2"
              current={false}
              completed={true}
              className="max-[6000px]:hidden"
            />
            <Tab
              num="3"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="4"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="5"
              current={false}
              completed={true}
              className="max-[420px]:hidden"
            />
            <Tab
              num="6"
              current={false}
              completed={true}
              className="max-[360px]:hidden"
            />
            <Tab num="7" current={false} completed={true} />
            <Tab
              // label="Language"
              label={`${language["lang_form8"]}`}
              current={true}
              completed={false}
            />
            <Tab num="9" current={false} completed={false} />
          </div>
          <div className="flex-col justify-start items-start gap-12 flex w-full">
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="firstName"
                >
                  {language["first_lang"]}
                </label>
              </div>
              <BasicSelect
                placeholder={`${language["lang_place"]}`}
                labelId="Language"
                selectMenu="language"
                value={lang_value}
                onChange={(event) => (setLan_value(event.target.value))}
                id="Language"
                menuItems={[...languages]}
              />
            </div>
            <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="lastName"
                >
                  {language["proficiency_level"]}
                </label>
              </div>
              <div className="w-full h-[54px] flex">
                <BasicSelect
                  placeholder={`${language["proficiency_level_place"]}`}
                  labelId="Proficiency"
                  selectMenu="rate"
                  value={lang_prof}
                  onChange={(event) => (setLan_prof(event.target.value))}
                  id="proficiency"
                  menuItems={[...rate]}
                />
              </div>
            </div>
            <div className="flex-col justify-start items-start gap-3 flex w-full">
              <AddMore text="language" onClick={handleAdd} />
              <p className="text-black text-base font-medium">
                {language["have_added"]}
              </p>
              <div className="flex flex-wrap gap-3">
                {chips?.map((languagess, key) => (
                  <AddedItem
                    item={languagess.language}
                    key={key}
                    delete={() => handleDelete(languagess)}
                  />
                ))}
              </div>
            </div>

{/*             <div className="flex-col justify-start items-start gap-2 flex w-full">
              <div className="flex gap-3 items-center">
                <div className="px-1 w-2 h-2 rounded-full bg-black"></div>
                <label
                  className="text-black text-base font-medium"
                  for="lastName"
                >
                  {language["resume_lang"]}
                </label>
              </div>
              <div className="w-full h-[54px] flex">
                <BasicSelect
                  placeholder={`${language["res_lang_place"]}`}
                  labelId="Resume language"
                  selectMenu="lang"
                  id="lang"
                  menuItems={[...lang]}
                />
              </div>
            </div> */}
           
{/*
            <div className="flex-col justify-start items-start gap-3 flex w-full">
              <p className="text-black text-base font-medium">
                {language["have_added"]}
              </p>
              <div className="flex flex-wrap gap-3">
                {chipsL?.map((lang, key) => (
                  <AddedItem
                    item={lang.lang}
                    key={key}
                    delete={() => handleDeletel(lang)}
                  />
                ))}
              </div>
              <AddMore text="langauge" onClick={handleAddl} />
            </div>
            </div> */}
          </div>
          <div className="self-stretch flex-col sm:flex-row justify-between items-start gap-4 inline-flex">
            <button
              className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
              onClick={
                props.handleStepChangeBack}
            >
              <span className="text-center text-orange-500 text-base font-semibold">
                {language["previous_btn"]}
              </span>
            </button>
            <button
              className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-center items-start gap-2.5 flex w-full sm:max-w-[200px]"
              onClick={handleNext}
            >
              <span className="text-center text-white text-base font-semibold whitespace-nowrap">
                {language["save_n_continue"]}
              </span>
            </button>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}